import styled from 'styled-components';
import BGImg from '../../assets/masthead.jpg';

const OnboardingWrapper = styled.div`
	background: #fff;
	font-family: Manrope, 'sans-serif';
	.masthead {
		background: linear-gradient(to bottom,#020e0459,#000000de),
		url(${BGImg});
		border-bottom: 2px solid #333;
		background-size: cover;
		background-position: center center;
		min-height: 600px;
		display: flex;
		align-items: center;
		span {
			color: #ffeb3b;
		}
		h1 {
			font-size: 50px;
			font-weight: 900;
			line-height: 60px;
			color: #fff;
			margin-bottom: 40px;
			@media (max-width: 1000px) {
				font-size: 33px;
				font-weight: 900;
				margin-bottom: 20px;
				line-height: 42px;
			}
		}
		p {
			font-size: 20px;
			color: #fff;
			margin-bottom: 40px;
			@media (max-width: 1000px) {
				font-size: 18px;
			}
		}
		.btn {
			padding: 10px 40px;
			background: #fff;
			border-color: #fff;
			font-weight: 600;
			a {
				color: #000;
				text-decoration: none;
			}
			&:hover {
				background: #000;
				a {
					color: #fff;
					text-decoration: none;
				}
			}
		}
		@media (max-width: 1000px) {
			padding: 50px 20px;
		}
	}
	.brands {
		padding: 40px 0px;
		img:nth-child(1) {
			width: 300px;
		}
		img:nth-child(2) {
			width: 200px;
		}
		img:nth-child(3) {
			width: 300px;
		}
		img:nth-child(4) {
			width: 150px;
		}
	}
	.about {
		background: #000;
		padding: 90px 0px 70px;
		display: flex;
		align-items: center;
		text-align: center;
		span {
			font-size: 12px;
			font-weight: 800;
			color: #fff;
		}
		h3 {
			font-size: 40px;
			font-weight: 900;
			margin-bottom: 16px;
			margin-top: 4px;
			line-height: 30px;
			color: #fff;
		}
		p {
			font-size: 18px;
			color: #fff;
			margin-bottom: 20px;
			opacity: 0.8;
			line-height: 32px;
			font-weight: 500;
			@media (max-width: 1000px) {
				font-size: 16px;
				line-height: 27px;
				margin-bottom: 40px;
			}
		}
	}
	.services {
		background: #0c0a0b;
		/* border-bottom: 5px dotted #ffffff5e; */
		padding: 90px 0px;
		display: flex;
		align-items: center;
		text-align: center;
		span {
			font-size: 12px;
			font-weight: 800;
			color: #f2f2f2;
		}
		h3 {
			font-size: 40px;
			font-weight: 900;
			margin-bottom: 16px;
			margin-top: 4px;
			line-height: 30px;
			color: #fff;
		}
		p {
			font-size: 18px;
			color: #fff;
			margin-bottom: 20px;
			opacity: 0.7;
			line-height: 32px;
			font-weight: 500;
			@media (max-width: 1000px) {
				font-size: 16px;
				line-height: 27px;
				margin-bottom: 40px;
			}
		}
		.row-flex {
			display: flex;
			flex-wrap: wrap;
			margin-top: 40px;
		}
		.col-lg-3 {
			margin-bottom: 40px;
		}
		.about-item {
			border: 1px solid #ebedef;
			background: #fff;
			padding: 50px 30px 50px;
			border-radius: 6px;
			height: 100%;
			box-shadow: 1px 2px 5px 0 rgb(13 110 253 / 15%);
			h5 {
				font-size: 25px;
				font-weight: 900;
				margin-bottom: 8px;
				line-height: 30px;
				color: #000;
			}
			img {
				width: 30%;
				margin-bottom: 20px;
			}
			p {
				font-size: 16px;
				color: #000;
				margin-bottom: 0px;
				line-height: 27px;
				opacity: 0.8;
				@media (max-width: 1000px) {
					font-size: 16px;
					line-height: 27px;
				}
			}
			/* &:hover {
				border: 1px solid #0d6efd;
				background: #0d6efd;
				h5, p { color: #fff; }
				@media (max-width: 1000px) {
					border: 1px solid #ebedef;
					background: #fff;
					h5, p { color: #000; }
				}
			} */
		}
		@media (max-width: 1000px) {
			padding: 50px 20px;
		}
	}
	.projects {
		background: #000;
		padding: 90px 0px;
		display: flex;
		align-items: center;
		text-align: center;
		span {
			font-size: 12px;
			font-weight: 800;
			color: #fff;
		}
		h3 {
			font-size: 40px;
			font-weight: 900;
			margin-bottom: 16px;
			margin-top: 4px;
			line-height: 30px;
			color: #fff;
		}
		p {
			font-size: 18px;
			color: #fff;
			margin-bottom: 60px;
			opacity: 0.7;
			line-height: 32px;
			font-weight: 500;
			@media (max-width: 1000px) {
				font-size: 16px;
				line-height: 27px;
				margin-bottom: 40px;
			}
		}
		.row-flex {
			display: flex;
			flex-wrap: wrap;
			margin-bottom: 50px;
			align-items: center;
		}
		.project-item {
			border-radius: 6px;
			height: 100%;
			text-align: left;
			&.project-item-text {
				padding: 50px 40px 50px;
				@media (max-width: 1000px) {
					padding: 20px 0px 0px;
				}
			}
			&.project-item-img {
				background: #fff;
				padding: 50px 40px 50px;
				margin-bottom: 20px;
				text-align: center;
				min-height: 400px;
				display: flex;
				align-items: center;
				justify-content: center;
				img {
					width: 80%;
				}
				@media (max-width: 1000px) {
					min-height: auto;
				}
			}
			h5 {
				font-size: 25px;
				font-weight: 900;
				margin-bottom: 8px;
				line-height: 30px;
				color: #ffeb3b;
			}
			p {
				font-size: 18px;
				color: #fff;
				margin-bottom: 16px;
				line-height: 33px;
				opacity: 0.9;
				@media (max-width: 1000px) {
					font-size: 16px;
					line-height: 27px;
				}
			}
			span {
				text-transform: capitalize;
			}
			span, a {
				font-size: 18px;
				color: #ffeb3b;
				margin-bottom: 16px;
				line-height: 33px;
				font-weight: 600;
				opacity: 1;
				/* text-decoration: none; */
			}
			@media (max-width: 1000px) {
				/* padding: 20px 20px 0px; */
			}
		}
		@media (max-width: 1000px) {
			padding: 50px 20px;
		}
	}
	.contact {
		background: #f2f2f2;
		min-height: 460px;
		display: flex;
		align-items: center;
	}
`;

export { OnboardingWrapper }